/**
 * @nubeteck/formeck (0.19.5)
 * Copyright (c) Nubeteck, SRL.
 */
import t from "react";
import { a as m } from "../../chunks/index.esm.eyITaPoj.js";
const r = t.memo(
  ({ name: e, children: a }) => a(m({ name: e, exact: !0 })),
  (e, a) => e.name === a.name
);
r.displayName = "UseWatchField";
export {
  r as default
};
